import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="precio" className="py-24 px-6 bg-navy text-center relative overflow-hidden" data-id="element-32">
      {/* Decorative background circles */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-33"></div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-2xl mx-auto relative z-10" data-id="element-34">
        <h2 className="text-4xl md:text-6xl font-serif text-cream mb-6" data-id="element-35">
          Comienza el Protocolo Hoy
        </h2>
        <p className="text-xl text-gold mb-10 font-light" data-id="element-36">
          Tu matrimonio merece estas próximas 72 horas.
        </p>

        <div className="mb-10 flex flex-col items-center" data-id="element-37">
          <span className="inline-block bg-gold/10 border border-gold/30 text-gold text-xs font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full mb-5" data-id="element-38">
            Oferta por tiempo limitado
          </span>
          <div className="flex items-baseline justify-center gap-4 flex-wrap" data-id="element-39">
            <div className="relative inline-flex flex-col items-center" data-id="element-40">
              <span className="bg-gold text-navy text-xs font-bold px-2.5 py-1 rounded-full uppercase tracking-wide mb-1" data-id="element-41">
                -76%
              </span>
              <span className="font-serif text-2xl text-cream/40 line-through" data-id="element-42">
                $27
              </span>
            </div>
            <span className="font-serif text-6xl md:text-7xl font-bold text-gold" data-id="element-43">
              $6.39
            </span>
          </div>
          <p className="text-cream/60 text-sm mt-3" data-id="element-44">
            Pago único · Sin suscripción
          </p>
        </div>

        <a href="https://vuelveavivir.com/cart/53782203400558:1" className="inline-block bg-gold text-navy px-10 py-5 rounded-sm font-semibold text-lg hover:bg-gold-light transition-colors duration-300 shadow-xl shadow-gold/20 w-full sm:w-auto" data-id="element-45">
          Acceder a la Guía Completa — $6.39
        </a>

        <div className="mt-8 flex items-center justify-center gap-4 text-cream/60 text-sm" data-id="element-46">
          <span data-id="element-47">Acceso inmediato</span>
          <span className="w-1 h-1 rounded-full bg-gold/50" data-id="element-48"></span>
          <span data-id="element-49">Garantía de 30 días</span>
        </div>
      </motion.div>
    </section>;
}